module.exports = __webpack_public_path__ + "static/img/s3.5f7dbcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social/s3.jpg
// module id = Q/bQ
// module chunks = 0